import React, { useEffect, useState } from 'react';
import 
  { Box, 
    CssBaseline, 
    Button, 
    ToggleButtonGroup,
    ToggleButton,
    Typography,
  } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import AppNavigation from './navigation';
import SubscriptionDashboard from './subsDash';
import AllAppsDashboard from './allApps';
import UsersDashboard from './user-dash/usersDash';

const APP_LIST = [
  { id: "674997d8c4aaadc4054b3372", name: "Anesthesia Assistant", icon: "/icons/anesthesia-assistant.png" },
  { id: "5e98254f2d1ce10e9431f525", name: "Nerve Blocks", icon: "/icons/nerve-blocks.png" },
  { id: "609a8163ddb62a107efb6a5c", name: "US Pain", icon: "/icons/us-pain.png" },
  { id: "60d19b028ac2e540ca51bbdc", name: "VetRA", icon: "/icons/vetra.png" },
  { id: "60ddae1f7ffdc227199348ce", name: "Interventional Pain", icon: "/icons/interventional-pain.png" },
  { id: "610280ea01c6203e11f777ea", name: "MSK US Knee", icon: "icons/mskknee.png" },
  { id: "63a1becbe53caf5ce853f91f", name: "Pocus", icon: "/icons/pocus.png" },
  { id: "65a7e37abb2a9f5281b10bce", name: "IV Access", icon: "/icons/iv-access.png" },
];

const AppAnalytics = ({ handleLogout }) => {
  const [loading, setLoading] = useState(true);

  const [selectedApp, setSelectedApp] = useState(() => {
    return localStorage.getItem(process.env.REACT_APP_STORAGE_SELECTED_APP) || APP_LIST[0].id;
  });

  const [showAllApps, setShowAllApps] = useState(() => {
    return localStorage.getItem(process.env.REACT_APP_STORAGE_SHOW_ALL_APPS) === 'true';
  });

  const ANESTHESIA_ASSISTANT_ID = "674997d8c4aaadc4054b3372";
  const isAnesthesiaAssistant = selectedApp === ANESTHESIA_ASSISTANT_ID && !showAllApps;
  useEffect(() => {
  if (!isAnesthesiaAssistant) {
    setViewDashboard("subscriptions"); 
    localStorage.setItem("view_mode", "subscriptions");
  }
}, [isAnesthesiaAssistant]);


  const [darkMode, setDarkMode] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(true);

  const [viewDashboard, setViewDashboard] = useState(() => {
    return localStorage.getItem('view_mode') || 'users';
  });

  const [activeScreen, setActiveScreen] = useState(() => {
    return localStorage.getItem("active_screen") || "app";
  });

  useEffect(() => {
    localStorage.setItem("active_screen", activeScreen);
  }, [activeScreen]);

  const handleOpenAllApps = () => {
    setShowAllApps(true);
    setActiveScreen("all");
  };

  const handleOpenApp = (appId) => {
    setSelectedApp(appId);
    setShowAllApps(false);
    setActiveScreen("app");

    setViewDashboard("users");
    localStorage.setItem("view_mode", "users");
  };

  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  useEffect(() => {
    localStorage.setItem(process.env.REACT_APP_STORAGE_SELECTED_APP, selectedApp);
  }, [selectedApp]);

  useEffect(() => {
    localStorage.setItem(process.env.REACT_APP_STORAGE_SHOW_ALL_APPS, showAllApps);
  }, [showAllApps]);

  const handleSelectDashboard = (mode) => {
    setViewDashboard(mode);
    localStorage.setItem('view_mode', mode);
  };

  const dashboardOptions = [
    {
      key: 'users',
      title: 'Users',
      icon: '/icons/users.svg',
    },
    {
      key: 'subscriptions',
      title: 'Analytics',
      icon: '/icons/analytics.svg',
    },
  ];

    const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: "none",
            borderRadius: "20px",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: "none",
            borderRadius: "20px",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: "17px",
            boxShadow: "none",
          }
        },
      },
    },
  });

  const SIDEBAR_W = 240;
  const TOP = 76;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "var(--bg-color)",
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          p: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
          <Box
            sx={{
              bgcolor:'white',
              borderTopRightRadius:'20px',
              borderTopLeftRadius: '20px',
              borderBottomLeftRadius: drawerOpen ? '0px' : '20px',
              borderBottomRightRadius: drawerOpen ? '0px' : '20px',
              width: '240px',
              display: "flex",
              alignItems: "center",
              gap: 3,
            }}
          >
            <Box
              component="img"
              src="/nysora-logo.png"
              alt="logo"
              sx={{ width: 134, height: 38, m: 2 }}
            />
            <Button
              variant="text"
              onClick={toggleDrawer}
              sx={{
                width: 30,
                height: 30,
                minWidth: 30,
                borderRadius: "50%",
              }}
            >
              {drawerOpen ? (
                <Box
                  component="img"
                  src="/icons/collapse-button.svg"
                  alt="collapse"
                  sx={{ width: 26, height: 26 }}
                />
              ) : (
                <Box
                  component="img"
                  src="/icons/expand-arrow.svg"
                  alt="expand"
                  sx={{ width: 26, height: 26 }}
                />
              )}
            </Button>
          </Box>
          
            {isAnesthesiaAssistant ? (
              <Box
                sx={{
                  width: '240px',
                  height: '68px',
                  borderRadius: '20px',
                  bgcolor: selectedApp == APP_LIST[0].id ? 'white' : 'var(--bg-color)',
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ToggleButtonGroup
                  value={viewDashboard}         
                  exclusive
                  onChange={(_e, value) => {
                    if (value !== null) {
                      handleSelectDashboard(value); 
                    }
                  }}
                  sx={{
                    padding: "8px",
                    "& .MuiToggleButton-root": {
                      textTransform: "none",
                      border: "none",
                      borderRadius: "20px",
                      px: 2.5,
                      py: 0.5,
                      color: "#7588B7",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#EFF3FE",
                      color: "#000",
                    },
                    "& .MuiToggleButton-root.Mui-selected:hover": {
                      backgroundColor: "rgba(25,118,210,0.08)",
                    },
                  }}
                >
                  {dashboardOptions.map(opt => (
                  <ToggleButton key={opt.key} value={opt.key}>
                    <Box
                      component="img"
                      src={opt.icon}            
                      alt="icon"
                      sx={{
                        width: 22,
                        height: 26,         
                        objectFit: "cover",
                        mr: 0.5,
                      }}
                    />
                    {opt.title}
                  </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </Box>
              ) : (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', ml: 2 }}>
                <Typography variant="h4" gutterBottom color="#003ABA">
                  { showAllApps ? "Dashboard" : "Analytics"}
                </Typography>
              </Box>
            )}
          </Box>
             
        {/* MAIN LAYOUT: sidebar + dashboard */}
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            minHeight: 0,
            gap: 2,
          }}
        >
          {/* SIDEBAR (tvoj "drawer") – postoji samo kad je open */}
          {drawerOpen && (
            <Box 
              sx={{
                position: "fixed",
                left: 8,                 // jer imaš p:1 (8px)
                top: TOP,
                width: SIDEBAR_W,
                height: `calc(100vh - ${TOP}px - 8px)`,
                zIndex: 10,
              }}
            >       
              <AppNavigation 
                selectedApp={selectedApp} 
                setSelectedApp={setSelectedApp}
                showAllApps={showAllApps}
                setShowAllApps={setShowAllApps}
                APP_LIST={APP_LIST}
                handleLogout={handleLogout}
                setLoading={setLoading}
                loading={loading}
              />
            </Box>
          )}

          {/* DASHBOARD DESNO – uvijek prisutan, širi se kad se zatvori sidebar */}
          <Box
            sx={{
              height: `calc(100vh - ${TOP}px - 20px)`,
              overflowY: "auto",
              minHeight: 0,
              ml: drawerOpen ? `${SIDEBAR_W + 16}px` : 0, // +gap
              width: drawerOpen ? `calc(100% - ${SIDEBAR_W + 16}px)` : "100%",
              borderRadius: "20px",
              bgcolor: "var(--bg-color)",
              p: 0.5,
              width: '100%',
              transition: (theme) =>
                theme.transitions.create(["margin-left", "width"], {
                  easing: theme.transitions.easing.easeInOut,
                  duration: theme.transitions.duration.standard, 
                })
            }}
          >
            {showAllApps ? (
              <AllAppsDashboard
                APP_LIST={APP_LIST}
                setLoading={setLoading}
                loading={loading}
              />
            ) : isAnesthesiaAssistant ? (
              viewDashboard === "users" ? (
                <UsersDashboard
                  selectedApp={selectedApp}
                  setLoading={setLoading}
                  loading={loading}
                />
              ) : (
                <SubscriptionDashboard
                  selectedApp={selectedApp}
                  APP_LIST={APP_LIST}
                  setLoading={setLoading}
                  loading={loading}
                />
              )
            ) : (
              <SubscriptionDashboard
                selectedApp={selectedApp}
                APP_LIST={APP_LIST}
                setLoading={setLoading}
                loading={loading}
              />
            )}
            </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AppAnalytics;
